import { createContext, useContext, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getContact, updateContact } from "../../api/contact";
import { getIntialValues, generatePayload } from "./helper";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();

  const getContactQuery = useQuery({
    queryKey: ["contact"],
    queryFn: getContact,
  });

  const updateContactMutation = useMutation({
    mutationFn: updateContact,
    onSuccess: () => {
      toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
      getContactQuery.refetch();
    },
    onError: () => {
      toaster.error(Const.MESSAGES.FAILED, "Error updating Contact page.");
    },
  });

  const initialValues = useMemo(() => {
    const contactData = getContactQuery?.data?.data || {};
    return getIntialValues(contactData);
  }, [getContactQuery?.data]);

  const handleSubmit = (values) => {
    const payload = generatePayload(values);
    updateContactMutation.mutate(payload);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        updateContactQuery: updateContactMutation,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const usePageProvider = () => {
  return useContext(PageContext);
};
